// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n4PcG","option":"styles_option__1kW9N","active":"styles_active__39hpd"};